module.exports = __webpack_public_path__ + "icon-purse.png?a9d5fac550d6a995c3853a1b4790bc4d";